<template>
  <li title="Zprávy" class="chat-notification">
    <div class="dropdown dropleft">
      <button
        type="button"
        class="btn btn-link"
        id="messagesDropdown"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <span class="icon icon-message"></span>
      </button>
      <span v-show="countMessages > 0" class="badge badge-pill badge-warning">{{ countMessages }}</span>

      <div class="dropdown-menu" aria-labelledby="messagesDropdown">
        <a href="#" class="text-center dropdown-item">Nové zprávy</a>
        <a
          v-for="(message, conversation_id) in messages"
          :key="conversation_id"
          class="dropdown-item text-black"
          :href="`/products/${message.product_id}?conversation=${conversation_id}`"
        >
          <strong>{{ message.fullname }}:</strong>
          {{ previewText(message.body) }}
        </a>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  data() {
    return {
      messages: {}
    }
  },
  computed: {
    countMessages() {
      return Object.keys(this.messages).length
    }
  },
  async mounted() {
    if (location.pathname.startsWith('/orders/')) return

    const conversations = await axios.get('/chat/conversations').then((r) => r.data)

    conversations.forEach((conversation) => {
      Echo.join(`mc-chat-conversation.${conversation.id}`)
        .listen('MessageWasSent', ({ message }) => {
          message.product_id = conversation.product_id
          message.fullname = `${message.sender.firstname} ${message.sender.lastname}`
          this.$set(this.messages, message.conversation_id, message)
        })
    })

    this.addUnreadMessages()
  },
  methods: {
    async addUnreadMessages() {
      const messages = await axios.get('/chat/messages/unread').then((r) => r.data)

      messages.forEach((message) => {
        this.$set(this.messages, message.conversation_id, message)
      })
    },
    previewText(text) {
      const maxLength = 40
      if (text.length <= maxLength) return text
      return text.substr(0, maxLength) + '...'
    }
  }
}
</script>
